import React from 'react';
import {Button, Grid, Input, Modal} from 'semantic-ui-react';
import {socket} from "../../lib/socketio";
import _ from "lodash";
import {isAuthorized } from '../../lib/authorization';
import { useSelector } from 'react-redux';
import { createUserLog } from '../../lib/api';

const CalibColumn = ({ index, column, data}) => {

    const [tagdata, settagdata]= React.useState('');
    const [open, setOpen] = React.useState(false);
    const [isValidationError, setIsValidationError] = React.useState(false);
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);
    const [log, setLog]= React.useState('');


    const handleOpen = (id) => setOpen({...open, [id]: true});

    const handleClose = (id) => {
        setIsValidationError(false);
        settagdata('');
        setOpen({...open, [id]:false});
    };

    const handleSubmit = (event, id) => {
        event.preventDefault();
        if(typeof tagdata === 'undefined' || tagdata === ''){
            setOpen({...open, [id]:false});
        }
        else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]:false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    }

    const handleChange = (event, value, id, min, max, display_id) => {
        event.preventDefault();
        if(event.target.value < min || event.target.value > max){
            setIsValidationError(true);
        }
        else {
            setIsValidationError(false);
            settagdata(event.target.value);
            if(!electronApp){
                setLog({'user_id': user.id, 'powerplant_id': ppid, 'display_id': display_id, 'datetime': new Date().toISOString(), data: JSON.stringify({'tag_id': [id]}) })
            }
        }

    }

    // [UPDATE] FR1.7 5 decimal -> FR1.7, CAL_MFC012_GAIN, CAL_FT012_GAIN
    const getDecimal = (id) => {
        const fiveDecimalIds = new Set([7493, 11407, 15321, 19235, 23149, 6816, 10730, 14644, 18558, 22472]);

        if(id === 3971){
            return '0.000001'; // 6 decimals
        } else if(fiveDecimalIds.has(id)){
            return '0.00001'; // 5decimals
        }else {
            return '0.0001'; // 4 decimals
        }
    }
 

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <>
                <Grid columns = 'equal' inverted celled = 'internally' stackable style={styles.grid} >
                    <Grid.Column style = {styles.name} width={3}>{column[i][column[i].length - 1].tag_display_subgroup}</Grid.Column>
                    {column[i].map(r =>
                        <Grid.Column style = {styles.column} >
                            {("tag_display_name" in r) ?
                                <>
                                    <Button
                                        key = 'button'
                                        type = 'button'
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {data[r.id]}
                                        style={{marginLeft : '0px', marginRight : '25px'}}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    {/** //update SOFC 240404 by sumin, to sort tagsw*/}
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                        <Modal.Content>
                                            <form autoComplete='off'
                                                  onSubmit={(event, value) => handleSubmit(event,r.id)}>
                                                <Input focus autoFocus placeholder='Value'
                                                       name='Input change'
                                                       type='number'
                                                       step={getDecimal(r.id)}
                                                       size='small'
                                                       min={r.min}
                                                       max={r.max}
                                                       error={isValidationError}
                                                       onChange={(event, value) => handleChange(event, value, r.id, r.min, r.max, r.display_id)}
                                                       defaultValue={data[r.id]}
                                                /> {r.unit}
                                            </form>
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button color='blue' content={'Ok'} disabled={isValidationError} onClick={(event, value) => handleSubmit(event,r.id)}/>
                                            <Button
                                                key = 'button'
                                                content = 'Close'
                                                color = 'red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick ={() => handleClose(r.id)}/>
                                        </Modal.Actions>
                                    </Modal>{r.unit}
                                </>
                                :
                                ''}
                        </Grid.Column>
                    )}
                </Grid>
            </>
        ))
    ));


    return (
        <Grid.Column>
            <Grid columns = 'equal' divided style ={{marginLeft: '10px'}}>
                <Grid.Row key={index} style={styles.row}>
                    <Grid.Column width={3}></Grid.Column>
                    <Grid.Column style={styles.header_color} width={2} key='UPDATE TIME'>UPDATE TIME</Grid.Column>
                    <Grid.Column style={styles.header_color} width={2} key='SCALE FACTOR'>SCALE FACTOR</Grid.Column>
                    <Grid.Column style={styles.header_color} width={2} key='OFFSET'>OFFSET</Grid.Column>
                    <Grid.Column style={styles.header_color_2} width={2} key='CALIB. RANGE LOW LIMIT'>LOW LIMIT</Grid.Column>
                    <Grid.Column style={styles.header_color_2} width={2} key='CALIB. RANGE HIGH LIMIT'>HIGH LIMIT</Grid.Column>
                    <Grid.Column style={styles.header_color} width={2} key='TAU'>TAU</Grid.Column>
                </Grid.Row>
            </Grid>
            <Grid.Row key={index} style={styles.row} >
                {gridColumn}
            </Grid.Row>
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0'
    },
    row: {
        maxWidth: '1600px'
    },
    name: {
        color: 'yellow'
    },
    header_color: {
        color: '#05AC05',
        fontWeight: 'bold'
        // paddingLeft : '0px'
    },
    header_color_2:{
        color: '#05AC05',
        fontWeight: 'bold',
        marginLeft : '10px'
    },
    header: {
        marginLeft: '50px',
        marginRight:'50px',
        textAlign: 'justified'
    },
    width: {
        maxWidth: '300px'
    },
    checkbox1: {
        flexDirection: 'row-reverse',
        marginLeft: '10px'
    },
    column: {
        paddingBottom: '0'
    }
};

export default React.memo(CalibColumn);

